// 发票语言，对应crm后台发票模板的语言，只需要设置非英文的部分
export const invoiceLanguageData = {
  Malaysia: {
    "en+ms": {
      invoice: "(Invois)",
      taxInvoice: "(Invois Cukai)",
      creditInvoice: "(Invois Kredit)",
      creditTaxInvoice: "(Invois Kredit Cukai)",
      date: "(TARIKH)",
      invoiceNumber: "(No. Invois)",
      creditInvoiceNumber: "(No. Invois Kredit)",
      transactionNo: "(No. Transaksi)",
      dueDate: "(Tarikh Akhir)",
      to: "(Kepada)",
      name: "(Nama)",
      address: "(Alamat)",
      country: "(Negara)",
      code: "(Kod)",
      attention: "(Perhatian)",
      description: "(PENERANGAN)",
      amount: "(JUMLAH)",
      refundOf: "(Bayaran Balik)",
      serviceCharge: "(Caj Perkhidmatan)",
      thirdPartyFee: "(Yuran Pihak Ketiga)",
      otherFee: "(Yuran Lain)",
      less: "(Tolak)",
      handlingFee: "(Yuran Pengendalian)",
      govFee: "(Yuran Gov)",
      remarks: "(Catatan)",
      totalDue: "(Jumlah Dibayar {excludedStr})",
      totalDueExcluded: "(tidak termasuk {taxTypeStr})",
      ofWhich: "(Di mana,)",
      taxableExcluded: "(Boleh Dicukai (tidak termasuk {taxType}))",
      taxRate: "(Kadar {taxType})",
      taxDue: "({taxType} Perlu Dibayar)",
      totalDueIncluded: "(Jumlah Perlu Dibayar (termasuk cukai))",
      originalInvoiceNo: "(No. Invois Asal)",
      originalInvoiceDate: "(Tarikh Invois Asal)",
      paymentInstruction: "(Arahan Pembayaran)",
      pleaseMakeCheque: "Sila buat cek atas nama {billFromName}. Atau pembayaran boleh dibuat terus ke akaun {billFromName} di bawah.",
      thisIsAnElectronically: "(Ini adalah resit yang dijana secara elektronik. Tandatangan tidak diperlukan.)",
    },
  },
  Thailand: {
    "en+th": {
      invoice: "(ใบแจ้งหนี้)",
      taxInvoice: "(ใบแจ้งหนี้ภาษี)",
      creditInvoice: "(ใบลดหนี้)",
      creditTaxInvoice: "(ใบลดหนี้ภาษี)",
      date: "(วันที่)",
      invoiceNumber: "(เลขที่ใบแจ้งหนี้)",
      creditInvoiceNumber: "(เลขที่ใบลดหนี้)",
      transactionNo: "(เลขที่รายการ)",
      dueDate: "(วันครบกำหนด)",
      to: "(ถึง)",
      name: "(ชื่อ)",
      address: "(ที่อยู่)",
      country: "(ประเทศ)",
      code: "(รหัส)",
      attention: "(เรียน)",
      description: "(รายละเอียด)",
      amount: "(จำนวนเงิน) ",
      refundOf: "(การคืนเงินของ)",
      serviceCharge: "(ค่าบริการ)",
      thirdPartyFee: "(ค่าธรรมเนียมบุคคลที่สาม)",
      otherFee: "(ค่าธรรมเนียมอื่นๆ)",
      less: "(หักออก)",
      handlingFee: "(ค่าธรรมเนียมการจัดการ)",
      govFee: "(ค่าธรรมเนียม Gov)",
      remarks: "(หมายเหตุ)",
      totalDue: "(ยอดที่ต้องชำระ{excludedStr})",
      totalDueExcluded: "(ไม่รวม{taxTypeStr})",
      ofWhich: "(ในจำนวนนี้)",
      taxableExcluded: "(ยอดที่คิด{taxType})",
      taxRate: "(อัตรา{taxType})",
      taxDue: "({taxType}ที่ต้องชำระ)",
      totalDueIncluded: "(ยอดรวมที่ต้องชำระ (รวมภาษี))",
      originalInvoiceNo: "(เลขที่ใบแจ้งหนี้ต้นฉบับ)",
      originalInvoiceDate: "(วันที่ใบแจ้งหนี้ต้นฉบับ)",
      paymentInstruction: "(Arahan Pembayaran)",
      pleaseMakeCheque: "กรุณาสั่งจ่ายเช็คในนาม {billFromName} หรือโอนเงินเข้าบัญชีของ {billFromName} ตามด้านล่าง",
      thisIsAnElectronically: "(นี่คือใบเสร็จที่สร้างโดยระบบอิเล็กทรอนิกส์ ไม่ต้องใช้ลายเซ็น)",
    },
  },
  Indonesia: {
    "en+id": {
      invoice: "(Faktur)",
      taxInvoice: "(Faktur Pajak)",
      creditInvoice: "(Faktur Kredit)",
      creditTaxInvoice: "(Faktur Kredit Pajak)",
      date: "(TANGGAL)",
      invoiceNumber: "(No. Faktur)",
      creditInvoiceNumber: "(No. Faktur Kredit)",
      transactionNo: "(No. Transaksi)",
      dueDate: "(Tanggal Jatuh Tempo)",
      to: "(Kepada)",
      name: "(Nama)",
      address: "(Alamat)",
      country: "(Negara)",
      code: "(Kode)",
      attention: "(Perhatian)",
      description: "(KETERANGAN)",
      amount: "(JUMLAH)",
      refundOf: "(Pengembalian dana)",
      serviceCharge: "(Biaya Layanan)",
      thirdPartyFee: "(Biaya Pihak Ketiga)",
      otherFee: "(Biaya Lainnya)",
      less: "(Dikurangi)",
      handlingFee: "(Biaya Penanganan)",
      govFee: "(Biaya Gov)",
      remarks: "(Keterangan)",
      totalDue: "(Total Tagihan {excludedStr})",
      totalDueExcluded: "(belum termasuk {taxTypeStr})",
      ofWhich: "(Di mana,)",
      taxableExcluded: "(Kena {taxType})",
      taxRate: "(Tarif {taxType})",
      taxDue: "({taxType} Terutang)",
      totalDueIncluded: "(Total Tagihan (termasuk pajak))",
      originalInvoiceNo: "(No. Faktur Asli)",
      originalInvoiceDate: "(Tanggal Faktur Asli)",
      paymentInstruction: "(Instruksi Pembayaran)",
      pleaseMakeCheque: "Silakan buat cek atas nama {billFromName}. Atau pembayaran dapat ditransfer langsung ke rekening {billFromName} di bawah.",
      thisIsAnElectronically: "(Ini adalah kuitansi yang dibuat secara elektronik. Tidak diperlukan tanda tangan.)",
    },
  },
  Philippines: {
    "en+fil": {
      invoice: "(Invoys)",
      taxInvoice: "(Invoys ng Buwis)",
      creditInvoice: "(Kredit Invoys)",
      creditTaxInvoice: "(Kredit Invoys ng Buwis)",
      date: "(PETSA)",
      invoiceNumber: "(Numero ng Invoys)",
      creditInvoiceNumber: "(Numero ng Kredit Invoys)",
      transactionNo: "(Blg. ng Transaksyon)",
      dueDate: "(Takdang Petsa)",
      to: "(Sa)",
      name: "(Pangalan)",
      address: "(Tirahan)",
      country: "(Bansa)",
      code: "(Kodigo)",
      attention: "(Pansin)",
      description: "(PAGLALARAWAN)",
      amount: "(HALAGA)",
      refundOf: "(Refund ng)",
      serviceCharge: "(Bayad sa Serbisyo)",
      thirdPartyFee: "(Bayad sa Ikatlong Partido)",
      otherFee: "(Iba pang Bayad)",
      less: "(Bawas)",
      handlingFee: "(Bayad sa Paghawak)",
      govFee: "(Bayad sa Gov)",
      remarks: "(Mga Tala)",
      totalDue: "(Kabuuang Dapat Bayaran {excludedStr})",
      totalDueExcluded: "(hindi kasama ang {taxTypeStr})",
      ofWhich: "(Kung saan,)",
      taxableExcluded: "(Taxable (hindi kasama ang {taxType})",
      taxRate: "(Buwis {taxType})",
      taxDue: "(Dapat Bayaran na {taxType})",
      totalDueIncluded: "(Kabuuang Dapat Bayaran (kasama ang buwis))",
      originalInvoiceNo: "(Numero ng Orihinal na Invoys)",
      originalInvoiceDate: "(Petsa ng Orihinal na Invoys)",
      paymentInstruction: "(Instruksyon sa Pagbabayad)",
      pleaseMakeCheque: "Mangyaring gumawa ng tseke para sa {billFromName}.O ang bayad ay maaaring ilipat direkta sa account ng {billFromName} sa ibaba.",
      thisIsAnElectronically: "(Ito ay elektronikong nabuong resibo. Hindi kailangan ng lagda.)",
    },
  },
};
